import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import CosmoHeads from '../components/CosmoHeads';
import CosmoAttentionLevels from '../components/CosmoAttentionLevels';
import AssessmentDashboard from '../components/AssessmentDashboard';

const DemoPage = () => {
  const { t } = useLanguage();
  
  return (
    <div className="min-h-screen bg-gray-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-8"
        >
          <h1 className="text-4xl font-bold text-gray-900 mb-4">COSMO Assessment Tool Demo</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-6">
            Experience how COSMO guides clinicians with simplicity through different levels of clinical attention
          </p>
          
          <div className="bg-blue-50 border-l-4 border-blue-400 p-4 rounded-r-lg max-w-2xl mx-auto text-left mb-8">
            <div className="flex items-start">
              <svg className="w-6 h-6 text-blue-600 mr-2 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <div>
                <p className="text-blue-800 font-bold mb-1">Come utilizzare questa demo:</p>
                <ul className="list-disc pl-5 text-blue-800 text-sm space-y-1">
                  <li>Ogni scheda mostra un assessment con un punteggio e livello di attenzione clinica</li>
                  <li>I colori delle schede indicano il livello di attenzione clinica (verde, giallo, rosso)</li>
                  <li>Per vedere la descrizione completa, clicca sul pulsante <span className="px-2 py-0.5 bg-green-600 text-white rounded-md inline-block">Leggi di più</span> in fondo alla scheda</li>
                </ul>
              </div>
            </div>
          </div>
        </motion.div>

        <div className="mb-12">
          <AssessmentDashboard />
        </div>
      </div>
    </div>
  );
};

export default DemoPage;